define.alias("shared/components/shared/post/secondary/caption-writer/disclaimer", "settings/components/shared/post/secondary/caption-writer/disclaimer");